"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const colors = {
  type: 'light',
  background: {
    default: '#F6F7F9',
    primary: {
      light: '#FFFFFF',
      main: '#FFFFFF',
      dark: '#101010'
    },
    secondary: '#2862A4',
    tertiary: '#000000',
    gradient: {
      light: '#222021',
      dark: '#101010'
    }
  },
  primary: {
    lightest: '#D4E6FB',
    light: '#3076C5',
    main: '#2862A4',
    contrastText: '#FFFFFF'
  },
  secondary: {
    lightest: '#686868',
    light: '#373A3C',
    main: '#000000',
    border: '#2862A4',
    contrastText: '#FFFFFF'
  },
  tertiary: {
    light: '#D4E6FB',
    main: '#FFFFFF',
    contrastText: '#000000'
  },
  quaternary: {
    light: '#E2251C',
    main: '#BF0A0A',
    contrastText: '#FFFFFF'
  },
  error: {
    main: '#E1251B',
    contrastText: '#FFFFFF'
  },
  border: {
    contrast: '#000000',
    primary: '#CBCBCB',
    secondary: '#686868',
    dark: '#7F7F7F'
  },
  img: {
    backgroundLoading: '#555a5d'
  },
  text: {
    primary: '#000000',
    secondary: {
      light: '#CBCBCB',
      main: '#525658',
      dark: '#9B9B9B'
    },
    tertiary: '#FFFFFF',
    quaternary: '#3076C5',
    active: '#2862A4',
    link: '#2862A4'
  },
  site: {
    background: '#FFFFFF',
    contrastText: '#000000',
    activeText: '#2862A4',
    mobile: {
      background: '#FFFFFF',
      contrastText: '#686868',
      activeText: '#2862A4'
    }
  }
};
var _default = exports.default = colors;